import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminManualInvoiceDetailsRaw = React.lazy(() => import(/* webpackChunkName: "AdminManualInvoiceDetails" */ './InvoiceDetails'));
export const AdminManualInvoiceDetails = () => (React.createElement(Page, { title: "Manual Invoice", description: "Manual Invoice" },
    React.createElement(Main, { sidebar: true },
        React.createElement("div", { className: "container-fluid att-main no-pad-r" },
            React.createElement("div", { className: "no-pad attorney-wrap " },
                React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
                    React.createElement(AdminManualInvoiceDetailsRaw, null)))))));
